import { ListItemBadge } from "@components/ListItemCardCst/types";

export interface EnrollmentStatusSource {
  status?: string | null;
  completeDate?: string | null;
  progPerc?: number | null;
}

const STATUS_KEY_BY_CODE: Record<string, string> = {
  E: "to-start",
  P: "in-progress",
  R: "refused",
  F: "failed",
  C: "completed",
  X: "exempt",
  EXEMPTED: "exempt",
  T: "top-down-needed",
  W: "waiting-approval",
  PW: "waiting-enrollment-request",
  PA: "waiting-self-enrollment",
  PA0: "waiting-self-enrollment",
};

const VARIANT_BY_KEY: Record<string, ListItemBadge["variant"]> = {
  completed: "success",
  "in-progress": "info",
  refused: "error",
  failed: "error",
  "top-down-needed": "warning",
};

export const resolveEnrollmentStatusKey = ({
  status,
  completeDate,
  progPerc,
}: EnrollmentStatusSource): string => {
  const byCode = status ? STATUS_KEY_BY_CODE[status] : undefined;
  if (byCode) return byCode;
  if (completeDate) return "completed";
  if ((progPerc ?? 0) > 0) return "in-progress";
  if (status === "N") return "not-enrolled";
  return "to-start";
};

export const enrollmentStatusVariant = (
  statusKey: string,
): ListItemBadge["variant"] => VARIANT_BY_KEY[statusKey] ?? "default";
